/* eslint-disable react/no-unused-prop-types */
import "react-dates/initialize";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import cx from "classnames";
import { injectIntl } from "react-intl";
import isEmpty from "lodash/isEmpty";
import { closeUspPage, sendMessageToParent } from "actions/integration";
import {
  clearSignUpGate,
  getUserSession,
  logout,
  redirectCustomerToSS,
  redirectLVCustomerToSS,
  toggleAuthMethod,
  impersonate,
  impersonateOCM,
} from "actions/authentication";
import { pushGaStepEvent } from "actions/loan";
import hideCookiesBar from "actions/legalAgreements";
import { affiliateInitRequest } from "tracking/affiliate";
import {
  addGtmScript,
  logoutAndImpersonate,
  getParametersFromUrl,
} from "utils/helpers";
import SignupGateContainer from "containers/Credit24/LoanApplication/SignupGateContainer";
import Spinner from "components/Credit24/Core/Spinner";
import UspPage from "components/common/UspPage";
import PageHeader from "components/Credit24/Core/PageHeader";
import PageFooter from "components/Credit24/Core/PageFooter";
import CookiesBar from "components/Credit24/LoanApplication/CookiesBar";
import Redirect from "components/common/Redirect";
import LegacyRedirect from "components/Credit24/LoanApplication/LegacyRedirect";
import injectTranslations from "utils/injectTranslations";
import { CREDIT_APPLICATION_STATE_APPROVED } from "consts/loan/creditApplicationStates";
import { CHANNEL_LEADMARKET } from "consts/loan/channels";

const propTypes = {
  children: PropTypes.object,
  loan: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  authentication: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  getUserSession: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  sendMessageToParent: PropTypes.func.isRequired,
  hideCookiesBar: PropTypes.func.isRequired,
  cookiesBarHidden: PropTypes.bool.isRequired,
  redirectCustomerToSS: PropTypes.func.isRequired,
  redirectLVCustomerToSS: PropTypes.func.isRequired,
  clearSignUpGate: PropTypes.func.isRequired,
  toggleAuthMethod: PropTypes.func.isRequired,
  closeUspPage: PropTypes.func.isRequired,
  pushGaStepEvent: PropTypes.func.isRequired,
  nordigen: PropTypes.object.isRequired,
  impersonate: PropTypes.func.isRequired,
  impersonateOCM: PropTypes.func.isRequired,
};

class Application extends Component {
  constructor(props) {
    super(props);
    this.state = {
      containerStyles: null,
    };
    this.updateContainerTopPadding = this.updateContainerTopPadding.bind(this);
    this.navigateToLoginFromSignupGate =
      this.navigateToLoginFromSignupGate.bind(this);
  }

  UNSAFE_componentWillMount() {
    const urlParams = getParametersFromUrl(
      this.props.router.getCurrentLocation().search,
    );
    const utmSource = urlParams.get("utm_source");
    const token = urlParams.get("token");

    if (utmSource === CHANNEL_LEADMARKET && !token) {
      this.redirectToRejection();
      return;
    }

    if (utmSource === CHANNEL_LEADMARKET && token) {
      this.redirectToImpersonationCoffeePage();
      return;
    }

    if (!EMBEDDED) {
      const {
        logout: _logout,
        impersonateOCM: _impersonateOCM,
        impersonate: _impersonate,
        getUserSession: _getUserSession,
      } = this.props;

      logoutAndImpersonate(
        _logout,
        _impersonateOCM,
        _impersonate,
        _getUserSession,
      );
    } else {
      this.props.sendMessageToParent({
        messageType: "LOAN_APP_EVENT",
        eventType: "appReady",
      });
    }
  }

  componentDidMount() {
    const { query } = this.props.location;

    if (query) {
      const { status } = query;
      const shouldRedirectToLogin =
        status === "verified" || status === "existing";

      if (shouldRedirectToLogin) {
        this.props.toggleAuthMethod(true);
        this.props.router.replace("/login", { query });
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const wereParamsPassed = nextProps.params.isParamsPassed;
    if (EMBEDDED && !this.props.params.isParamsPassed && wereParamsPassed) {
      affiliateInitRequest(nextProps);
      this.props.getUserSession();
      addGtmScript(nextProps.params.gtmIdentifier);
    }
    if (!this.props.cookiesBarHidden && nextProps.cookiesBarHidden) {
      this.setState({
        containerStyles: null,
      });
    }

    const { authentication, router } = this.props;
    const { identificationState, contracts } = nextProps.authentication;
    if (COUNTRY === "AU") {
      if (
        !authentication.identificationState &&
        identificationState &&
        identificationState === "NOT_STARTED_YET" &&
        (!contracts || contracts.length === 0)
      ) {
        router.replace(`/welcome${location.search}${location.hash}`);
        return;
      }
    }

    if (
      !authentication.isAuthenticated &&
      nextProps.authentication.isAuthenticated
    ) {
      const { location, replace } = router;
      let { from } = location.state || { from: { pathname: "/loan" } };
      if (nextProps.authentication.isChangingPassword) {
        from = { pathname: "/change-password" };
      }
      if (
        nextProps.loan.bankScrapingResult &&
        nextProps.loan.bankScrapingResult.status
      ) {
        // clean query string in case of redirect from Proviso
        replace(from);
        return;
      }
      replace(`${from.pathname}${location.search}${location.hash}`);
      return;
    }

    if (
      this.props.location.pathname !== nextProps.location.pathname &&
      nextProps.location.action === "PUSH"
    ) {
      window.scrollTo(0, 0);
      if (EMBEDDED) {
        if (wereParamsPassed && nextProps.params.inline) {
          this.props.sendMessageToParent({
            messageType: "LOAN_APP_EVENT",
            eventType: "scrollToTop",
          });
        }
      }
    }

    const isApplicationApproved = COUNTRY === 'AU' && nextProps.loan?.state === CREDIT_APPLICATION_STATE_APPROVED;

    if (authentication && !authentication.isRedirecting) {
      let shouldRedirectCustomerToSelfService;

      if (INCREASE_APP) {
        shouldRedirectCustomerToSelfService =
          contracts && contracts.length === 0;
      } else {
        shouldRedirectCustomerToSelfService = !isEmpty(contracts);
      }

      if (isApplicationApproved) {
        shouldRedirectCustomerToSelfService = false;
      }

      if (shouldRedirectCustomerToSelfService) {
        if (COUNTRY === "LV") {
          this.props.redirectLVCustomerToSS(contracts);
        } else {
          this.props.redirectCustomerToSS();
        }
        return;
      }
    }

    if (this.props.authentication.isAuthenticated
      && this.props.authentication.authenticationMethod !== 'IMPERSONATION'
      && !this.props.authentication.shouldShowConsentPage
      && nextProps.authentication.shouldShowConsentPage) {
      router.replace('/loan/consents');
      return;
    }

    // Check if the user has all consents accepted
    if (!this.props.loan.isLoanSubmitted
      && nextProps.loan.isLoanSubmitted
      && !nextProps.authentication.shouldShowConsentPage) {
      router.push('/follow-up-questions');
      return;
    }


    const userHasConsentsAccepted =
      !this.props.loan.isLoanSubmitted &&
      nextProps.loan.isLoanSubmitted &&
      !nextProps.authentication.shouldShowConsentPage;

    const userHasJustAcceptedConsents =
      this.props.loan.isLoanSubmitted &&
      this.props.authentication.shouldShowConsentPage &&
      !nextProps.authentication.shouldShowConsentPage;

    const shouldShowFollowUpForBroker =
      this.props.loan.channel === "broker_app" &&
      !this.props.loan.isLoanSubmitted &&
      nextProps.loan.isLoanSubmitted;

    const shouldShowFollowUpQuestions =
      userHasConsentsAccepted ||
      userHasJustAcceptedConsents ||
      shouldShowFollowUpForBroker;

    if (shouldShowFollowUpQuestions) {
      router.push("/follow-up-questions");
      return;
    }

    if (
      authentication.isChangingPassword &&
      !nextProps.authentication.isChangingPassword
    ) {
      router.replace(`/loan${location.search}${location.hash}`);
      return;
    }

    const index = nextProps.loan.currentStep;
    if (
      this.props.loan.currentStep !== index &&
      index >= 0 &&
      !this.props.loan.isLoanSubmitted
    ) {
      const path = `${nextProps.loan.steps[index].path}`;
      if (path !== this.props.location.pathname) {
        if (
          index > this.props.loan.currentStep &&
          this.props.loan.currentStep > 0
        ) {
          router.push(`${path}${location.search}${location.hash}`);
        } else {
          router.replace(`${path}${location.search}${location.hash}`);
        }
      }
    }
  }

  redirectToImpersonationCoffeePage = () => {
    const { router } = this.props;
    router.push(`/impersonation-coffee-page${location.search}${location.hash}`);
  };

  redirectToRejection = () => {
    const { router } = this.props;
    router.push("/rejection");
  };

  navigateToLoginFromSignupGate() {
    this.props.toggleAuthMethod(true);
    this.props.clearSignUpGate();
  }

  updateContainerTopPadding(cookiesBarHeight) {
    if (!this.props.cookiesBarHidden && COUNTRY !== "LT") {
      this.setState({
        containerStyles: { paddingTop: `${cookiesBarHeight}px` },
      });
    }
  }

  render() {
    const { authentication, loan, params, children, intl } = this.props;
    const { isParamsPassed, uspPageUrl } = params;
    const containerClasses = cx({
      "page-container": true,
      "page-container--hidden": EMBEDDED && !isParamsPassed,
      "page-container--embedded": EMBEDDED && isParamsPassed,
    });

    if (EMBEDDED && !isParamsPassed) {
      return (
        <div className="page-container">
          <Spinner />
        </div>
      );
    }

    let pageContent = React.Children.map(children, (child) =>
      React.cloneElement(child, { loan, authentication, intl }),
    );

    if (EMBEDDED && uspPageUrl) {
      pageContent = (
        <UspPage url={uspPageUrl} closeUspPage={this.props.closeUspPage} />
      );
    } else if (authentication.isRedirecting) {
      pageContent = <Redirect />;
    } else if (authentication.isRedirectingLegacyCustomer) {
      pageContent = <LegacyRedirect />;
    }

    let showLoginButton = false;
    if (
      !authentication.isAuthenticated &&
      (authentication.isSignUpGate || loan.isServiceUnavailable)
    ) {
      pageContent = <SignupGateContainer intl={intl} />;

      if (!loan.isServiceUnavailable) {
        showLoginButton = true;
      }
    }

    return (
      <div className={containerClasses} style={this.state.containerStyles}>
        {!this.props.cookiesBarHidden && COUNTRY !== "LT" && (
          <CookiesBar
            onClose={this.props.hideCookiesBar}
            updateContainerTopPadding={this.updateContainerTopPadding}
          />
        )}
        <div className="page-wrapper">
          <PageHeader
            authentication={authentication}
            params={params}
            logout={this.props.logout}
            showLoginButton={showLoginButton}
            navigateToLogin={this.navigateToLoginFromSignupGate}
          />
          <div className="page-content">{pageContent}</div>
        </div>
        <PageFooter params={params} intl={intl} />
      </div>
    );
  }
}

Application.propTypes = propTypes;

export default injectTranslations(
  connect(
    (state) => ({
      authentication: state.authentication,
      loan: state.loan,
      params: state.integration,
      cookiesBarHidden: state.legalAgreements
        ? state.legalAgreements.cookiesBarHidden
        : true,
      nordigen: state.nordigen,
    }),
    {
      getUserSession,
      logout,
      sendMessageToParent,
      hideCookiesBar,
      redirectCustomerToSS,
      redirectLVCustomerToSS,
      clearSignUpGate,
      toggleAuthMethod,
      closeUspPage,
      pushGaStepEvent,
      impersonate,
      impersonateOCM,
    },
  )(injectIntl(Application)),
);
